import React from 'react';
import Entry from './Entry.js'
import { Row, Col } from 'reactstrap'

const Entrylist = ({ search, entries, deleteEntry, searchEntries }) => {
    if (entries === null) return null

    if (search) {
        if (entries.length === 0) {
            return (
                <h5>No results for "{search}"</h5>
            )
        }
    }

    return (
        <div>
            {search && (
                <h5>Results for "{search}"</h5>
            )}
            {entries.map((entry, index) => (
                <Row key={index}>
                    <Col>
                        <Entry
                            entry={entry}
                            deleteEntry={deleteEntry}
                            searchEntries={searchEntries}
                        />
                    </Col>
                </Row>
            ))}
        </div>
    )
}

export default Entrylist
